import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-ktm',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>KTM icon</title><path d="M0 15.735h3.354l.843-2.06 1.55 2.06h7.225l2.234-2.081-.372 2.081h2.83L20 13.675l-.32 2.06h3.052L24 9.99h-3.068l-2.486 2.191.48-2.19h-2.942l-3.209 3.216 1.342-3.938h4.907l.225-1.003H6.381l-.378 1.003h4.732l-1.994 5.054-1.572-2.066L9.886 9.99H7.612l-2.787 2.23.938-2.23H2.44L0 15.735Z"/></svg>`,
    styles: []
})
export class SimpleIconsKtmComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#FF6600';
    @Input() className: string = 'simple-icons-ktm'
    constructor() {}
    ngOnInit(): void {}
}
